import styled from 'styled-components'

export const SliderContainer = styled.div`
  width: 100%;

  & .rc-slider-dot:first-of-type, .rc-slider-dot:last-of-type {
    display: none;
  }
`